// extracted by mini-css-extract-plugin
export default {"trustPilotAgency":"style-module--trustPilotAgency--5be52","trustPilot":"style-module--trustPilot--e0ae0"};